// Kept separate from lessons.js so the site header can link here without
// pulling lesson data into the main bundle.
export const LEARN_PYTHON_PATH = "/learn-python";

export const topicPath = (lessonSlug, topicId) =>
  `${LEARN_PYTHON_PATH}/${lessonSlug}/${topicId}`;
